var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
var Ng1UserExistsInviteDirective = /** @class */ (function (_super) {
    __extends(Ng1UserExistsInviteDirective, _super);
    function Ng1UserExistsInviteDirective(elementRef, injector) {
        return _super.call(this, 'usersInviteExist', elementRef, injector) || this;
    }
    return Ng1UserExistsInviteDirective;
}(UpgradeComponent));
export { Ng1UserExistsInviteDirective };
